<template lang="pug">
#heat_seal
  section.banner.position-relative
    div.picture
        img.img-fluid.big(src="img/banner/banner_heat_seal.jpg" alt="banner-certificate")
        img.img-fluid.small(src="img/banner/banner_heat_seal_mobile.jpg" alt="banner-certificate")
    div.mask_banner
    div.breadcrumb_block
      b-container
        b-breadcrumb(:items="breadcrumb_items")
    div.banner_h1
      h1 熱封
  b-container.py-0.py-lg-5.slogan
    p.text-center.font-weight-bolder.py-5 使用介質加熱法將要用高週波熔接的塑膠產品放在兩片金屬板中間，高週波電壓被連接到這兩塊電極，通電後分子在高週波電場內開始振盪加熱，到達必要的溫度後，塑膠材料開始熔合接合。將兩層塑膠產品放在高週波電場裏同時加熱加壓，它們就會堅固的接合在一起。
  section#product_profile
    b-row.menu
      b-col.text-center.active APET
    b-container.pt-md-4
      b-row#apet_detail.detail.pb-5.py-md-5.active
        b-col(cols="12" md="8" order="2" order-md="1")
          div
            h3 
              span 產品特點
            p 1.本製品透明度佳、成型性良好，膠布經真空成型後可作高週波熱封貼合，製作文具、玩具、工具、禮品等各種商品之包裝材料。	
              br
              |2.2.經添加抗黏劑後可用於文具折盒，及使用溶劑貼合膠布製作文具、玩具、化妝品、禮品等各種商品之包裝材料。
          div
            h3 
              span 產品特性
            ol
              li(v-for="item in a_feature" :key="item.message") {{ item.message }}
          div
            h3 
              span 產品用途
            ol
              li(v-for="item in a_use" :key="item.message") {{ item.message }}
        b-col.align-self-center.text-center.pb-5.pb-md-0(cols="12" md="4" order="1" order-md="2")
          swiper.swiper.swiper_product_img(:options="swiperOption_product_img")
            swiper-slide(v-for="item in product_img_data" :key="item.id")
              b-img.w-100(:src="item.img_src",:alt="item.img_alt",:title="item.img_alt" )
            div.swiper-pagination(slot="pagination")
  section#specification.py-5.active
    div.mask
    h2.text-center 
      span  APET 產品規格
    b-container(fluid)
      swiper.swiper.py-5(:options="swiperOption_apet").swiper_apet.swiper_product_col_2
        swiper-slide(v-for="item in a_specification" :key="item.id")
          ul
              li 
                span {{ item.name }}
              li 
                span {{ item.feature }}
              li 
                span {{ item.outward }}
              li 
                span(v-html="item.thickness")
              li 
                span(v-html="item.proportion")
              li 
                span(v-html="item.transmittance")
              li 
                span(v-html="item.gloss")
              li 
                span(v-html="item.mist")
        <div class="swiper-pagination" slot="pagination"></div>
  section#others.py-5 
    b-container
      h3 其他應用
      swiper.swiper.py-5(:options="swiperOption")
        swiper-slide(v-for="item in swiperdata" :key="item.id")
          div
            router-link(:to="item.href_link")
              div
                b-img.w-100(:src="item.url" fluid)
                h5 {{item.name}}
              p.py-4 {{item.text}}
              svg.o_arrow_r(viewbox="0 0 50 30")
                line(x1=0 y1=20 x2=45 y2=20)
                line(x1=45 y1=20 x2=31 y2=8)
        div.swiper-pagination(slot="pagination")
        div.swiper-button-prev(slot="button-prev")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75) rotate(180deg)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        div.swiper-button-next(slot="button-next")
          svg(width="65px" height="65px" viewBox="0 0 65 65" style="transform: scale( 1.75)")
            g(id="desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd")
              g(id="product" transform="translate(-1250.000000, -2680.000000)" stroke="#979797")
                  g(id="arrow" transform="translate(1282.500000, 2710.500000) rotate(-180.000000) translate(-1282.500000, -2710.500000) translate(1255.000000, 2683.000000)")
                    circle(stroke-width="1.1" fill="#FFFFFF" cx="27.3493151" cy="27.3493151" r="27.3493151")
                    polyline(stroke-width="3.3" stroke-linecap="round" stroke-linejoin="round" fill="none" points="29.0068493 19.0616438 20.7191781 27.3493151 29.0068493 35.6369863")
        

</template>
<script>
export default {
    metaInfo: {
        title: 'APET熱封-南亞硬質膠布',
        titleTemplate: '',
        meta: [
            { name: 'description', content: 'APET膠布透明度佳、成型性良好，膠布經真空成型後可作高週波熱封貼合，製作文具、玩具、工具、禮品等各種商品之包裝材料。有高週波熱封用、經濟級熱封用等。' },
            { name: 'Keywords', content: '南亞塑膠、硬質膠布、APET、熱封、高週波。' },
            { name: 'og:title', content: 'APET熱封-南亞硬質膠布' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: 'https://www.nan-ya-pvc.com.tw/' },
            { name: 'og:description', content: 'APET膠布透明度佳、成型性良好，膠布經真空成型後可作高週波熱封貼合，製作文具、玩具、工具、禮品等各種商品之包裝材料。有高週波熱封用、經濟級熱封用等。' },
            { name: 'og:image', content: 'https://www.nan-ya-pvc.com.tw/img/OGimage.jpg' },
        ],
    },
  data() {
      return {
        breadcrumb_items: [
          {
            text: 'Home',
            to: { name: 'App' }
          },
          {
            text: '熱封',
            active: true
          }
        ],
        swiperOption_product_img: {
          slidesPerView: 1,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        product_img_data: [
          { 
            id: '1',
            img_src: 'img/processing_Desktop/heat_seal_img_01.jpg',
            img_alt: '南亞APET膠布透明度佳、成型性良好，可高週波熱封貼合，製作各種商品之包裝材料' },
          { 
            id: '2',
            img_src: 'img/processing_Desktop/heat_seal_img_02.jpg',
            img_alt: '南亞APET膠布透明度佳、成型性良好，可高週波熱封貼合，製作各種商品之包裝材料' }
        ],
        p_show: [
          {show: true},
          {show: false}
        ],
        a_feature: [
          { message: '透明度佳。' },
          { message: '真空成型性良好。' },
          { message: '高週波熱封性佳。' }
        ],
        a_use: [
          { message: '可客製化項目：爽身、電暈、耐寒、抗靜電、防霧及高週波等。' },
          { message: '檢驗規範：ASTM D-1593、ASTM D-792、ASTM D-1003及ASTM D-523等。' }
        ],
        a_specification: [
          { 
            id: '1',
            name: '高週波熱封用AYVG',
            feature: '特色: 透明性佳、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub>：0.48 ',
            proportion: '比重<sub>(g/cm3)</sub>：1.33±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>:<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub>：<br/><span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦2.5</span>'},
          { 
            id: '2',
            name: '經濟級熱封用AYVZ',
            feature: '特色: 透明性佳、成型性良好',
            outward: '外觀: 透明、有色',
            thickness: '參考厚度<sub>(mm)</sub> ：0.3 ',
            proportion: '比重<sub>(g/cm3)</sub> ：1.33±0.01',
            transmittance: '透光度<sub>(透明製品,%)</sub>：<br/><span class="pl-5">88～92</span>',
            gloss: '光澤度<sub>(透明製品)</sub> ：<br/><span class="pl-5">158～168</span>',
            mist: '霞霧度<sub>(%)</sub>：<br/><span class="pl-5">≦2.5</span>' }
        ],
        swiperOption_apet: {
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            790: {
              spaceBetween: 30,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            },
            410: {
              spaceBetween: 10,
              slidesPerView: 'auto',
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            }
          }
        },
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 51,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            767: {
              slidesPerView: 1,
              spaceBetween: 50
            }
          }
        },
        swiperdata: [
          {
            id:'1',
            name:'真空成型',
            text:'採用吸塑設備，利用高溫及模具，將平面的塑膠片，成型出立體包裝曲面殼，以讓消費者可直接透視產品並保護之。',
            url:'./img/processing_Desktop/other_pic_pro_1.jpg',
            href_link: 'vacuum_forming'
          },
          {
            id:'2',
            name:'摺疊成型',
            text:'將完成印刷、上光、模切等加工的盒片半成品，依盒體的成型要求將盒片上膠、折疊、黏合成型，製作成可用於包裝使用的盒體。',
            url:'./img/processing_Desktop/other_pic_pro_2.jpg',
            href_link: 'folding_forming'
          },
          {
            id:'4',
            name:'印刷',
            text:'本製品可經印刷、上光、貼合或沖裁等工序製成各種印刷產品。',
            url:'./img/processing_Desktop/other_pic_pro_4.jpg',
            href_link: 'print'
          },
          {
            id:'5',
            name:'電鍍',
            text:'在真空條件下，通過蒸餾或濺射等方式在膠布表面沉積金屬薄膜，通過這樣的方式可以得到非常薄的表面鍍層，同時具有速度快附著力好的突出優點。',
            url:'./img/processing_Desktop/other_pic_pro_5.jpg',
            href_link: 'plating'
          }
        ]
      }
    },
  methods: {
    change:function(item) {
      if(item === 'PVC'){
        this.p_show[0].show = true
        this.p_show[1].show = false
      }
      else{
        this.p_show[1].show = true
        this.p_show[0].show = false
      }
      // for(let i in this.p_show){
      //   this.p_show[i].show = !this.p_show[i].show
      // }
      // this.p_show[0].show = false
      // this.p_show[1].show = true
      // this.p_show = !this.p_show
      // for(let i=0; i<this.p_show.length; i++){
      //   this.p_show[i] = !this.p_show[i]
      //   console.log(i)
      // }
      // console.log(this.p_show[1] + "," + this.p_show[0])
      }
      // if(event){
      //   this.p_show[0] = true
      //   this.p_show[1] = true
      //   console.log(this.p_show[1])}
    // }
  },
}
</script>
<style lang="sass">
@import '@/css/product.sass'
#heat_seal
  #specification
    background-image: url(../assets/bg/bg_heat_seal.jpg)


</style>
